const featureFlags = {
  CHAT_AI: {
    featureFlagEnvVar: 'VITE_CHAT_AI_FF',
  },
  GENERATE_APPEAL: {
    featureFlagEnvVar: 'VITE_APPEAL_GENERATION_FF',
  },
  HOSTED_UI: {
    featureFlagEnvVar: 'VITE_COGNITO_USE_HOSTED_UI',
  },
  HIDE_TRANSACTION_CODES: {
    featureFlagEnvVar: 'VITE_HIDE_TRANSACTION_CODES_FF',
  },
  WORK_ITEM_VISIT_COLUMN: {
    featureFlagEnvVar: 'VITE_WORK_ITEM_VISIT_COLUMN_FF',
  },
  ADVANCED_FILTERS: {
    featureFlagEnvVar: 'VITE_ADVANCED_FILTERS_FF',
  },
  LEADER_HUB: {
    featureFlagEnvVar: 'VITE_LEADER_HUB_FF',
  },
  AI_ADVISOR: {
    featureFlagEnvVar: 'VITE_AI_ADVISOR_FF',
  },
};

export default function isFeatureFlagEnabled(featureName) {
  const feature = featureFlags[featureName]?.featureFlagEnvVar;
  if (!feature) {
    console.warn(`Feature flag ${featureName} not found`);
    return false;
  }
  return Boolean(parseInt(import.meta.env[feature]) === 1);
}
